.table {
  max-height: 90vh;
  overflow-y: auto;

  .practiceplace {
    display: inline-flex;

    .arrowToggleBtn {
      transform: scale(0.9);
    }

    .icon {
      display: inline-flex;

      svg {
        margin: auto;
      }
    }

    .name {
      margin: auto;
      padding-left: 8px;
    }

    .nameStrong {
      font-weight: 600;
      margin: auto;
      padding-left: 8px;
    }
  }
}

.buttonContainer {
  display: flex;
  float: right;
  padding-top: 16px;

  button {
    margin-left: 15px;
    margin-top: 5px;
  }
}

.boxSizing {
  width: 221px !important;
}
